import Sr1 from '../Assets/Services/services 1.jpg';
import Sr2 from '../Assets/Services/services 2.jpg';
import Sr3 from '../Assets/Services/services 3.jpg';
import Sr4 from '../Assets/Services/services 4.jpg';
import Sr5 from '../Assets/Services/services 5.jpg';
import Sr6 from '../Assets/Services/services 6.jpg';


const Data=[
          
          
    {
        url:Sr1,
        name:"brake & repair service",
        content:"There are many variations of passages orem psum available but the majority have suffered alteration in some form by injected.",
        button:"read more",      
       },
           {
            url:Sr2,
            name:"engine & transmission",
            content:"There are many variations of passages orem psum available but the majority have suffered alteration in some form by injected.",
            button:"read more",
           },

           {
            url:Sr3,
            name:"heating & AC repairs",
            content:"There are many variations of passages orem psum available but the majority have suffered alteration in some form by injected.",
            button:"read more",
           },
           
           {
            url:Sr4,
            name:"engine upgrades",
            content:"There are many variations of passages orem psum available but the majority have suffered alteration in some form by injected.",
            button:"read more",
           },

           {
            url:Sr5,
            name:"tire & auto parts",
            content:"There are many variations of passages orem psum available but the majority have suffered alteration in some form by injected.",
            button:"read more",
           },

           {
            url:Sr6,
            name:"auto electric",
            content:"There are many variations of passages orem psum available but the majority have suffered alteration in some form by injected.",
            button:"read more",
           },
];

export default Data;